//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Features.DrawShapes.js";
import "../no/Builder.js";
import "../no/ScCollector.js";
import "../no/Expression.js";
import "../no/ugmath.js";
import "../no/Expression.js";
import "../no/ScCollector.js";
let d=[[[0,"CornerTreatment",1,0],[1,"CurvesToOffset",0,"ScCollector",0],[1,"OffsetDistance",0,"Expression",0],[0,"ReverseDirection",1,0],[1,"RoundRadius",0,"Expression",0]],[[["seedEntity","seedPoint"],"UpdateOnCurveSelection",{},2,0],[[],"DisplayPreviewCurves",{},0,0]],[]];
SPLM.Features.DrawShapes.OffsetCurveData = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Features.DrawShapes.OffsetCurveData";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Features.DrawShapes.OffsetCurveData.SharpCornerTreatment = Object.freeze({
    "Keep" : "Keep", "Round" : "Round"});

export default SPLM;